import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface ProposalCardProps {
  title: string;
  reasoning?: string;
  children: React.ReactNode;
  className?: string;
}

export function ProposalCard({ title, reasoning, children, className }: ProposalCardProps) {
  return (
    <Card className={`border border-border/30 shadow-sm ${className || ''}`}>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
        {reasoning && (
          <CardDescription className="mt-1 text-xs italic text-muted-foreground/70">
            {reasoning}
          </CardDescription>
        )}
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
